module.exports = __webpack_public_path__ + "img/theme14.b375c05f.png";